import React from 'react'

import { ErrorMessage, ErrorMessageProps } from './ErrorMessage'

import { ReactComponent as Logo } from '@sketch/icons/logo'

const DefaultIcon = ({
  iconSize,
  ...props
}: {
  iconSize?: string
  [key: string]: any
}) => {
  return <Logo width="46px" height="46px" {...props} />
}

export const GenericError = ({
  title = 'Something went wrong',
  icon = DefaultIcon,
  iconSize = 'small',
  description = (
    <>
      We&apos;re looking into the issue. Try again later or visit our{' '}
      <a href="https://status.sketch.com/">Status Page</a>.
    </>
  ),
  ...props
}: Partial<ErrorMessageProps>) => (
  <ErrorMessage
    title={title}
    icon={icon}
    iconSize={iconSize}
    description={description}
    {...props}
  />
)
